import { WorkpackService } from 'client/services';
import { formDataToJson } from 'client/utils/helpers/Workpack/Workpack';
import { v4 as uuid } from 'uuid';
import { logWithPrefix } from 'client/utils/logging';

const log = logWithPrefix('workpacks');
const logTitle = 'CreateWorkpack';

// The action now only submits the workpack request to the v2 endpoint.
// Previously it also fetched enquiry features and asset owners to build a print spec
// on the frontend — this is now handled entirely by the backend service.
const action = async ({ request }) => {
    const formData = await request.formData();
    const enquiry = formDataToJson(formData) || {};

    if (!enquiry?.userJourneyTransId) {
        enquiry.userJourneyStartTime = performance.now();
        enquiry.userJourneyTransId = uuid();
        log(logTitle, 'start journey using tx-id: ' + enquiry.userJourneyTransId);
    }

    if (request.method === 'POST') {
        const transId = enquiry.userJourneyTransId;
        const startTime = enquiry.userJourneyStartTime;

        delete enquiry.userJourneyTransId;
        delete enquiry.userJourneyStartTime;

        try {
            log(logTitle, 'end journey using tx-id: ' + transId + ', took: ' + (performance.now() - startTime).toFixed(2) + ' ms');

            const response = await WorkpackService.createWorkpackRequest(enquiry, transId);
            return {
                enquiry,
                createdWorkpackReqId: response?.workpackReqId
            };
        } catch (error) {
            enquiry.userJourneyTransId = transId;
            enquiry.userJourneyStartTime = startTime;
            return {
                enquiry,
                error
            };
        }
    }

    return {
        enquiry
    };
};

export default action;
